import { createContext, useContext, useState, useEffect } from 'react';
import { useSite } from './SiteContext';

const LocalContext = createContext();

export const LocalProvider = ({ children }) => {
  const { siteName, email, fullAddress } = useSite();
  const [webinfo, setwebinfo] = useState({
    name: siteName,
    email,
    address: fullAddress,
    addressCity: 'Oakland',
  });

  useEffect(() => {
    setwebinfo((prev) => ({
      ...prev,
      name: siteName,
      email,
      address: fullAddress,
    }));
  }, [siteName, email, fullAddress]);

  return (
    <LocalContext.Provider value={{ webinfo, setwebinfo }}>
      {children}
    </LocalContext.Provider>
  );
};

export const useLocalContext = () => useContext(LocalContext);
